import CompanyUser from "./CompanyUser";

export default CompanyUser;
